"use strict";
/**
 * Created on 07 13 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * <p>DTO object related to forecast change report. Encapsulates all relevant data needed for detection of change
 * on {@link WindowItem item} level.</p>
 *
 * @author JMe
 */


var WindowItemForecastChange =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowItemForecastChange, _DomainObject_1$Domai);

  /**
   * Ctor.
   *
   * @param id Corresponds to {@link WindowItem.id}.
   * @param promoPrice Corresponds to {@link WindowItem.promoPrice}.
   * @param promoVolume Corresponds to {@link WindowItem.promoVolume}.
   * @param groupOfSitesId Corresponds to {@link WindowItem.groupOfSitesId}.
   */
  function WindowItemForecastChange(id, promoPrice, promoVolume, groupOfSitesId) {
    var _this;

    _classCallCheck(this, WindowItemForecastChange);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowItemForecastChange).call(this));
    _this.id = id;
    _this.promoPrice = promoPrice;
    _this.promoVolume = promoVolume;
    _this.groupOfSitesId = groupOfSitesId;
    return _this;
  }

  return WindowItemForecastChange;
}(DomainObject_1.DomainObject);

exports.WindowItemForecastChange = WindowItemForecastChange;